"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _default = [".ttf", ".otf", ".eot", ".woff", ".woff2"];
exports["default"] = _default;